import { TaskListPopupComponent } from './task-list-popup.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { DxPopupModule, DxTextAreaModule, DxValidatorModule, DxValidationSummaryModule, DxDateBoxModule } from 'devextreme-angular';
import { TaskPopupModule } from "../task-popup/task-popup.module";



@NgModule({
    declarations: [TaskListPopupComponent],
    exports: [TaskListPopupComponent],
    imports: [
        CommonModule,
        DevEpressCommonModule,
        DxPopupModule,
        DxTextAreaModule,
        DxValidatorModule,
        DxValidationSummaryModule,
        DxDateBoxModule,
        TaskPopupModule
    ]
})
export class TaskListPopupModule { }
